export default __webpack_public_path__ + "static/media/cesto_more.278f6078.svg";